import React from "react";

function NavlogWindsControls({
  stationList = [],
  windsRegion,
  setWindsRegion,
  windsFcst,
  setWindsFcst,
  loadAllWinds,
}) {
  return (
    <>
      <hr />

      

      <div
        style={{
          display: "flex",
          gap: "18px",
          alignItems: "center",
          marginTop: "12px",
          marginBottom: "8px",
        }}
      >
        

        <div>
          <label style={{ marginRight: "8px", fontWeight: "bold" }}>
            Forecast Hours
          </label>

          <select
            value={windsFcst}
            onChange={(e) => setWindsFcst(e.target.value)}
          >
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
          </select>
        </div>

        <div>
          <label style={{ marginRight: "8px", fontWeight: "bold" }}>
            Level
          </label>
          <span>low</span>
        </div>
      </div>

      <div
        style={{
          marginTop: "12px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "flex-start",
          gap: "12px",
        }}
      >
        <button type="button" onClick={loadAllWinds}>
          Load All Winds
        </button>

        <button type="button" onClick={() => window.print()}>
          Print NAVLOG
        </button>
      </div>
    </>
  );
}

export default NavlogWindsControls;